"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function DisclaimerSections() {
  const { t } = useLanguage();
  return (
    <section className="bg-white py-14 md:py-16">
      <div className="max-w-[880px] mx-auto px-4 md:px-6">
        <div className="space-y-10 md:space-y-12">

          {/* 1. Business Identity */}
          <div>
            <h2 className="text-xl md:text-[26px] font-bold text-[#064e3b] mb-3">
              {t("legal.h2Identity")}
            </h2>
            <p className="text-base leading-[1.7] text-[#374151]">
              {t("legal.identityText")}
            </p>
          </div>

          {/* 2. What We Do / Don't Do */}
          <div>
            <h2 className="text-xl md:text-[26px] font-bold text-[#064e3b] mb-3">
              {t("legal.h2Scope")}
            </h2>
            <div className="space-y-4">
              <div>
                <p className="text-sm font-semibold text-[#047857] mb-1 uppercase tracking-wide">
                  {t("home.scopeDo")}
                </p>
                <p className="text-base leading-[1.7] text-[#374151]">
                  {t("legal.scopeDoText")}
                </p>
              </div>
              <div>
                <p className="text-sm font-semibold text-[#ea580c] mb-1 uppercase tracking-wide">
                  {t("home.scopeDont")}
                </p>
                <p className="text-base leading-[1.7] text-[#374151]">
                  {t("legal.scopeDontText")}
                </p>
              </div>
            </div>
          </div>

          {/* 3. Service Limitations */}
          <div>
            <h2 className="text-xl md:text-[26px] font-bold text-[#064e3b] mb-3">
              {t("legal.h2Limits")}
            </h2>
            <p className="text-base leading-[1.7] text-[#374151]">
              {t("legal.limitsText")}
            </p>
          </div>

          {/* 4. Who We Refer To */}
          <div>
            <h2 className="text-xl md:text-[26px] font-bold text-[#064e3b] mb-3">
              {t("legal.h2Refer")}
            </h2>
            <p className="text-base leading-[1.7] text-[#374151]">
              {t("legal.referText")}
            </p>
          </div>

          {/* 5. Contact Information */}
          <div>
            <h2 className="text-xl md:text-[26px] font-bold text-[#064e3b] mb-3">
              {t("legal.h2Contact")}
            </h2>
            <div className="bg-[#fefce8] rounded-xl p-6 border-l-4 border-[#047857] max-w-[600px]">
              <p className="font-bold text-[#064e3b] text-base mb-2">
                Windows and Doors Repair LLC
              </p>
              <p className="text-[#374151] text-sm mb-1">
                {t("legal.contactPhone")}
              </p>
              <p className="text-[#374151] text-sm mb-1">
                {t("legal.contactEmail")}
              </p>
              <p className="text-[#374151] text-sm mb-1">
                {t("legal.contactAddress")}
              </p>
              <p className="text-[#374151] text-sm italic">
                {t("legal.contactHours")}
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}